import { useMutation, useQuery, useQueryClient, type UseQueryResult } from "@tanstack/react-query";
import { api, type PmIntegration, type PmIntegrationsResponse } from "@/lib/api";

export const pmIntegrationsKey = ["pmIntegrations"] as const;

export function usePmIntegrations(): UseQueryResult<PmIntegrationsResponse> {
  return useQuery({
    queryKey: pmIntegrationsKey,
    queryFn: () => api.listPmIntegrations(),
    staleTime: 30_000,
  });
}

export function useCreatePmIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Parameters<typeof api.createPmIntegration>[0]) =>
      api.createPmIntegration(body),
    onSuccess() {
      qc.invalidateQueries({ queryKey: pmIntegrationsKey });
    },
  });
}

export function useUpdatePmIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      patch,
    }: {
      id: string;
      patch: Parameters<typeof api.updatePmIntegration>[1];
    }) => api.updatePmIntegration(id, patch),
    onSuccess() {
      qc.invalidateQueries({ queryKey: pmIntegrationsKey });
    },
  });
}

export function useDeletePmIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deletePmIntegration(id),
    onSuccess() {
      qc.invalidateQueries({ queryKey: pmIntegrationsKey });
    },
  });
}

export function useTestPmIntegration() {
  return useMutation({
    mutationFn: (id: string) => api.testPmIntegration(id),
  });
}

export type { PmIntegration };
